














































































import { Vue, Component } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { majorNoticeText } from '@/common/constants/index';

import getActivityType from '@/common/utils/getActivityType';
import getUrlParam from '@/common/utils/getUrlParam';
import ActivitySwitch from '@/components/common/edit/ActivitySwitch.vue';

@Component({
  components: {
    'activity-switch': ActivitySwitch
  }
})
export default class NumShow extends Vue {
  @Getter('showNum') showNum!: boolean;
  @Getter('xmMajordomo') xmMajordomo!: boolean;
  @Getter('xcxType') xcxType!: string;
  @Getter('xcxFlag') xcxFlag!: boolean;
  @Getter('limitNum') limitNum!: number;
  @Getter('leftQuota') leftQuota!: number;
  @Getter('tyTypeParameter') tyTypeParameter!: any;
  @Getter('bargainParameter') bargainParameter!: any;
  @Getter('groupCreateNumber') groupCreateNumber!: number;
  @Getter('groupCompleteNumber') groupCompleteNumber!: number;
  @Getter('section') section!: object;
  @Getter('payNumber') payNumber!: number;
  
  @Getter('joinNumber') joinNumber!: number;

  @Action('changeShowNum')
  changeShowNum!: Function;
  isCopy: boolean = false;
  templateType: string = getActivityType();
  pageType: string = getUrlParam('type') as string;
  getActivityType: Function = getActivityType;

  get prizeNum() {
    if (this.templateType === 'tyType' ) {
      return this.tyTypeParameter.prizeNum;
    }else if ( this.templateType === 'bargainType') {
      return this.bargainParameter.prizeNum;
    }
  }
  get leftNum() {
    if (this.templateType === 'tyType') {
      let num = this.tyTypeParameter.prizeLeftCount;
      return num;
    }
  }
  handleSwitchStatus(newStatus: boolean): void {
    if (this.xcxType === 'mkb') {
      return;
    }
    if (this.xcxFlag && !this.xmMajordomo) {
      Vue.$confirm({
        oneBtn: true,
        title: '提示',
        text: majorNoticeText,
        okText: '确定'
      });
      return;
    }
    this.changeShowNum(newStatus);
  }
}
